// Fill a form field, handling TomSelect instances
export function fillField(element, value) {
  if (element.tomselect) {
    element.tomselect.setValue(value);
  } else {
    element.value = value;
    element.dispatchEvent(new Event('change', {bubbles: true}));
  }
}

// Debounce a function call — preserves arguments and context.
// Returns a wrapper with a .cancel() method to clear pending calls.
export function debounce(fn, ms) {
  let timer = null;

  const wrapper = function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), ms);
  };

  wrapper.cancel = function () {
    clearTimeout(timer);
  };

  return wrapper;
}
